import { render } from "./TourInnerPoints.vue?vue&type=template&id=5c3d465d&scoped=true"
import script from "./TourInnerPoints.vue?vue&type=script&lang=js"
export * from "./TourInnerPoints.vue?vue&type=script&lang=js"

import "./TourInnerPoints.vue?vue&type=style&index=0&id=5c3d465d&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c3d465d"]])

export default __exports__